import { render } from "./NeuHeroSektion.vue?vue&type=template&id=52dedab8&scoped=true"
import script from "./NeuHeroSektion.vue?vue&type=script&lang=js"
export * from "./NeuHeroSektion.vue?vue&type=script&lang=js"

import "./NeuHeroSektion.vue?vue&type=style&index=0&id=52dedab8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dedab8"]])

export default __exports__